import DefaultLayout from '../layout/DefaultLayout';
import Breadcrumb from '../components/Breadcrumbs/Breadcrumb.tsx';
import ProtocolsView from '../components/Protocols/Protocol.tsx';
import {useParams} from "react-router-dom";


const Protocol = () => {
    const { id } = useParams();

    // You can now use protocolId to fetch data or perform other actions
    console.log('Protocol ID:', id);
    return (
        <DefaultLayout>
            <Breadcrumb pageName="Protocols" />
            <ProtocolsView/>
        </DefaultLayout>
    );
};

export default Protocol;
